import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
export default function BuyItAgainErrorAlert() {
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-4" },
        React.createElement(Alert, { status: "error" }, "We're unable to add this item to your cart. Refresh the page and try again.")));
}
